import { Record, Map as ImmutableMap } from 'immutable';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import TargetProperty from 'automation-ui-action-features/object-type-properties/TargetProperty';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as TargetPropertySourceTypes from 'automation-ui-action-features/object-type-properties/TargetPropertySourceTypes';
import findAssociationObjectTypeIdFromSpec from 'automation-ui-associations/utils/findAssociationObjectTypeIdFromSpec';
import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
import * as SetPropertyActionMetadataKeys from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadataKeys';
const emptyPropertyValue = new PropertyValue({
  type: 'STATIC_VALUE',
  value: '',
  propertyName: null,
  propertyToken: null,
  timeDelay: null,
  amount: 0,
  identifier: null
});
export default class SetPropertyActionMetadata extends Record({
  [SetPropertyActionMetadataKeys.ACTION_TYPE]: ActionTypes.SET_PROPERTY,
  [SetPropertyActionMetadataKeys.TARGET_PROPERTY]: null,
  [SetPropertyActionMetadataKeys.VALUE]: null
}, 'SetPropertyActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const targetProperty = propMap.get(SetPropertyActionMetadataKeys.TARGET_PROPERTY);
    const value = propMap.get(SetPropertyActionMetadataKeys.VALUE);
    super(propMap.set(SetPropertyActionMetadataKeys.TARGET_PROPERTY, new TargetProperty(targetProperty || {})).set(SetPropertyActionMetadataKeys.VALUE, new PropertyValue(value || {})));
  }
  getTargetProperty() {
    return this[SetPropertyActionMetadataKeys.TARGET_PROPERTY];
  }
  setTargetProperty(targetProperty) {
    return this.set(SetPropertyActionMetadataKeys.TARGET_PROPERTY, targetProperty);
  }

  /**
   * Used to know if the metadata is set up to "clear" a property
   * value
   */
  getIsValueEmpty() {
    return emptyPropertyValue.equals(this.getValue());
  }
  getTargetSource() {
    return this[SetPropertyActionMetadataKeys.TARGET_PROPERTY].getSource();
  }
  getTargetAssociation() {
    return this[SetPropertyActionMetadataKeys.TARGET_PROPERTY].getAssociationSpec();
  }
  setTargetAssociation(associationSpec) {
    return this.set(SetPropertyActionMetadataKeys.TARGET_PROPERTY, this.getTargetProperty().setAssociationSpec(associationSpec));
  }
  getTargetPropertyName() {
    return this[SetPropertyActionMetadataKeys.TARGET_PROPERTY].getPropertyName();
  }
  setTargetPropertyName(propertyName) {
    return this.set(SetPropertyActionMetadataKeys.TARGET_PROPERTY, this.getTargetProperty().setPropertyName(propertyName));
  }
  getValue() {
    return this[SetPropertyActionMetadataKeys.VALUE];
  }
  setValue(value) {
    return this.set(SetPropertyActionMetadataKeys.VALUE, value);
  }
  getValueType() {
    return this[SetPropertyActionMetadataKeys.VALUE].getType();
  }
  setValueType(valueType) {
    return this.set(SetPropertyActionMetadataKeys.VALUE, this.getValue().setType(valueType));
  }
  getValuePropertyName() {
    return this[SetPropertyActionMetadataKeys.VALUE].getPropertyName();
  }
  getValuePropertyToken() {
    return this[SetPropertyActionMetadataKeys.VALUE].getPropertyToken();
  }
  getValueIdentifierDataKey() {
    const identifier = this[SetPropertyActionMetadataKeys.VALUE].getIdentifier();
    return identifier ? identifier.getDataKey() : null;
  }
  getValueIdentifierActionId() {
    const identifier = this[SetPropertyActionMetadataKeys.VALUE].getIdentifier();
    return identifier ? identifier.getActionId() : null;
  }
  clearValueValue() {
    return this.set(SetPropertyActionMetadataKeys.VALUE, this.getValue().clearValue());
  }
  getValueValue() {
    var _this$SetPropertyActi;
    const value = (_this$SetPropertyActi = this[SetPropertyActionMetadataKeys.VALUE]) === null || _this$SetPropertyActi === void 0 ? void 0 : _this$SetPropertyActi.getValue();
    if (typeof value !== 'string' && typeof value !== 'number' && value !== undefined && value !== null) {
      console.warn(`Unexpected target property value for SetPropertyActionMetadata: ${value}. Expected types are string, number, undefined, null`);
    }
    return value;
  }
  getValueAmount() {
    return this[SetPropertyActionMetadataKeys.VALUE].getAmount();
  }
  setValueAmount(amount) {
    return this.set(SetPropertyActionMetadataKeys.VALUE, this.getValue().setAmount(amount));
  }
  getTargetObjectTypeId(associationDefinitionsQuery, flowObjectTypeId) {
    const assocType = this.getTargetSource();
    const targetAssociation = this.getTargetAssociation() || new AssociationSpec();
    return assocType === TargetPropertySourceTypes.OBJECT ? flowObjectTypeId : findAssociationObjectTypeIdFromSpec(targetAssociation, associationDefinitionsQuery);
  }
}